
import { createAction, props } from '@ngrx/store';
import { TipoEquipamientoLaboratorio } from './tipos-equipamiento-laboratorio.model';

export const entityTipoEquipamientoLaboratorioLoadRequest = createAction(
  '[ENTITYTIPOEQUIPAMIETOLABORATORIO] Load Request'
);

export const entityTipoEquipamientoLaboratorioLoadFailure = createAction(
  '[ENTITYTIPOEQUIPAMIETOLABORATORIO] Load Failure',
  props<{ error: Error | any }>()
);

export const entityTipoEquipamientoLaboratorioLoadSuccess = createAction(
  '[ENTITYTIPOEQUIPAMIETOLABORATORIO] Load Success',
  props<{ items: TipoEquipamientoLaboratorio[] }>()
);
